const state = {
  routes: [],
  updateSize: null,
  keepPages: [],
};

const mutations = {
  _setToken(state, accessToken) {
    state.accessToken = accessToken;
  },
  _setEncryptedAccessToken(state, encryptedAccessToken) {
    state.encryptedAccessToken = encryptedAccessToken;
  },
  _setUser(state, user) {
    state.userInfo = user;
  },
  _setUpdateSize(state, value) {
    state.updateSize = value;
  },
  _delPage(state, page) {
    const pages = state.keepPages.filter((item) => item !== page);
    if (pages) {
      state.keepPages = pages;
    }
  },
  _addPage(state, page) {
    state.keepPages.push(page);
  },
  _setRoutes(state, page) {
    state.keepPages.push(page);
  },
  setRoutes(state, page) {
    state.routes.push(page);
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
